import { render, staticRenderFns } from "./DeliveryNote.vue?vue&type=template&id=75c79228&scoped=true"
import script from "./DeliveryNote.vue?vue&type=script&lang=js"
export * from "./DeliveryNote.vue?vue&type=script&lang=js"
import style0 from "./DeliveryNote.vue?vue&type=style&index=0&id=75c79228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c79228",
  null
  
)

export default component.exports